var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'core', 'app-common/hotkey-helper', 'app-common/component/service-call', 'app-common/component/notes', 'component/categorizer', 'template/report/overview-view.htm', 'app-common/lib/jquery.velocity', 'app-common/lib/jquery.flexselect'], function($, _, _s, Backbone, core, hotkeyHelper, serviceCall, NotesView, Categorizer, overviewViewTemplate) {
  var OverviewView;
  return OverviewView = (function(_super) {

    __extends(OverviewView, _super);

    function OverviewView() {
      OverviewView.__super__.constructor.apply(this, arguments);
    }

    OverviewView.prototype.className = 'overview-view';

    OverviewView.prototype.events = {
      'click .overview-view__edit-toggle:not(.disabled)': 'saveOverview',
      'click .overview-view__icon-button': 'clickChild'
    };

    OverviewView.prototype.$notes = function() {
      return this.$('.overview-view__notes');
    };

    OverviewView.prototype.initialize = function(options) {
      OverviewView.__super__.initialize.apply(this, arguments);
      if (!(options != null ? options.hasFeature : void 0)) {
        return this;
      }
      this.ledgerCollection = core.getCollection('ledgerAccounts');
      this.categorizer = new Categorizer(core.getCurrentClientId());
      return this.initHotkeys();
    };

    OverviewView.prototype.initHotkeys = function() {
      var _this = this;
      $(document).off('keydown.overview-view');
      return $(document).on('keydown.overview-view', function(e) {
        if (_this.isVisible() && hotkeyHelper.isCtrlAndKeyDown(e, 'S')) {
          e.preventDefault();
          return _this.$el.find('.overview-view__edit-toggle').click();
        }
      });
    };

    OverviewView.prototype.render = function(ledgerId, notification) {
      var ledger, rules, rulesArray, rulesString;
      ledger = this.ledgerCollection.get(ledgerId);
      this.ledger = ledger;
      rules = this.categorizer.getLedgerRules(ledgerId);
      rulesArray = _.map(rules, function(rule) {
        return rule.get('vendorContains');
      });
      rulesString = rulesArray.length ? rulesArray.join(', ') : null;
      this.$el.html(_.template(overviewViewTemplate, {
        ledger: (ledger != null) && ledger.attributes,
        rules: rulesString,
        notification: notification
      }));
      return this.renderNotes(ledgerId);
    };

    OverviewView.prototype.renderNotes = function(ledgerId) {
      var _ref;
      if (this.notesView) {
        return (_ref = this.notesView) != null ? _ref.render(this.$notes()) : void 0;
      }
      return this.notesView = new NotesView({
        ledgerId: ledgerId,
        $container: this.$notes()
      });
    };

    OverviewView.prototype.hide = function() {
      return this.$el.parent().velocity('stop').velocity('transition.slideRightOut', {
        duration: 100,
        queue: false
      });
    };

    OverviewView.prototype.show = function(ledgerId) {
      this.render(ledgerId);
      return this.$el.parent().velocity('stop').velocity('transition.slideRightIn', {
        duration: 500,
        queue: false
      });
    };

    OverviewView.prototype.successNotification = function(msg) {
      return {
        status: 'success',
        text: msg
      };
    };

    OverviewView.prototype.failureNotification = function(msg) {
      return {
        status: 'failure',
        text: msg
      };
    };

    OverviewView.prototype.isVisible = function() {
      return this.$el.is(':visible');
    };

    OverviewView.prototype.saveOverview = function() {
      var details, promise,
        _this = this;
      details = this.$el.find('#detailsInput').val();
      this.ledger.set({
        details: details
      });
      promise = this.ledger.save();
      promise.success(function() {
        _this.render(_this.ledger, _this.successNotification('Overview update successful!'));
        return _this.trigger('overview-details-update');
      });
      return promise.fail(function() {
        return _this.render(_this.ledger, _this.failureNotification('Overview update failed. Try again later.'));
      });
    };

    OverviewView.prototype.clickChild = function(e) {
      if (e.target !== e.currentTarget) {
        return;
      }
      return $(e.currentTarget).find('.control').click();
    };

    return OverviewView;

  })(Backbone.View);
});
